import { render, staticRenderFns } from "./contentCardBaseE.vue?vue&type=template&id=3c229a24&scoped=true"
import script from "./contentCardBaseE.vue?vue&type=script&lang=js"
export * from "./contentCardBaseE.vue?vue&type=script&lang=js"
import style0 from "./contentCardBaseE.vue?vue&type=style&index=0&id=3c229a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c229a24",
  null
  
)

export default component.exports